import React, { createContext, useContext as useContextCore } from 'react'
import type { Colors } from '@ztechapps/common.hook'
import { QUICKSCORE_BRAND_GREEN } from '@ztechapps/quickscore.common'
import { ThemeProvider, ToastProvider } from '@ztechapps/webui.util'
import { ConfirmDialogProvider } from '@ztechapps/webui.modal'
import { DependencyProvider } from '@ztechapps/webui.contract'
import { setupContainer } from '../../config/setup-container'

export type AppContextType = {
  data?: any
}

const context = createContext<AppContextType>(null as any)
const CoreProvider = context.Provider

// Feeds react-select's theme: `primary` is the selected-option background, and its white label
// sits on it at 5.123:1. The 75/50/25 suffixes are progressively lighter sage tints, primary25
// lightest; 75 and 50 exist only here, so they stay plain literals.
// COUPLING: `primary25` must match --sage-soft in
// apps/quickscore/website/src/brand.css and `primaryContainer` in
// apps/quickscore/mobile/src/paperTheme.ts — a CSS custom property cannot be read from TS, and
// Metro cannot resolve `@ztechapps/*` from the mobile app, so neither twin can be imported here.
const themeColors: Colors = {
  primary: QUICKSCORE_BRAND_GREEN,
  primary75: '#669A4F',
  primary50: '#96C283',
  primary25: '#D9EAD1',
}

const container = setupContainer()

export const AppContextProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <DependencyProvider container={container}>
      <CoreProvider value={{}}>
        <ToastProvider>
          <ThemeProvider routerType="react-router" colors={themeColors}>
            <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
          </ThemeProvider>
        </ToastProvider>
      </CoreProvider>
    </DependencyProvider>
  )
}

export const useAppContext = () => useContextCore(context)
